import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=a2f004c0&scoped=true&"
import script from "./SettingItem.vue?vue&type=script&lang=ts&"
export * from "./SettingItem.vue?vue&type=script&lang=ts&"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=a2f004c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f004c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VChip,VIcon})
